import { getStatisticSprintByProject, getSprintByProject } from '@/api/sprint';
export default {
  namespaced: true,
  state: {
    projectMap: new Map(),
    requestPadding: {},
    sprintList: []
  },
  mutations: {
    SET_PROJECT_MAP(state, data) {
      state.projectMap.set(data.projectId, data.info);
    },
    SET_SPRINT_LIST_CHANGE(state, projectId) {
      if (state.projectMap.has(projectId)) {
        state.projectMap.get(projectId).dirty = true;
        if (state.projectMap.get('all')) {
          state.projectMap.get('all').dirty = true;
        }
      }
    },
    SET_SPRINT_List(state, data) {
      state.sprintList = data;
    }
  },
  actions: {
    getProjectSprintList({ state, commit }, Id) {
      let projectId = Id;
      if (Id === null) {
        projectId = 'all';
      }
      if (state.requestPadding[projectId]) {
        return state.requestPadding[projectId];
      }
      state.requestPadding[projectId] = new Promise((resolve, reject) => {
        if (state.projectMap.has(projectId) && !state.projectMap.get(projectId)?.dirty) {
          return resolve(state.projectMap.get(projectId).sprintList);
        }
        getStatisticSprintByProject(Id).then(res => {
          const info = {
            dirty: false,
            sprintList: res
          };
          commit('SET_PROJECT_MAP', { info: info, projectId: projectId });
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      }).finally(() => {
        state.requestPadding[projectId] = null;
      });
      return state.requestPadding[projectId];
    },
    async changeCurrentProjectSprint({ commit }, projectId) {
      try {
        const res = await getSprintByProject(projectId);
        commit('SET_SPRINT_List', res);
      } catch (err) {
        console.log('SET_SPRINT_List', err);
      }
    },
    updateCurrentProjectSprint({ commit }, data) {
      commit('SET_SPRINT_List', data);
    }
  },
  getters: {
    sprintList: state => {
      return state.sprintList;
    },
    sprintListNumber: state => {
      return state.sprintList.length;
    }
  }
};
